import { useMemo } from "react";
import { useQuery } from "@apollo/client";
import {
  GetClassRoomsWhereTeacherWasCandidateQuery,
  GetClassRoomsWhereTeacherWasCandidateQueryResult,
} from "../../BookedClassRooms/useTeacherCandidateClassRooms.ts";

export function useClassRoomIdsLostByTeacher({
  teacherId,
  competingClassRoomIds,
}: {
  teacherId: string;
  competingClassRoomIds: string[];
}) {
  const { data, loading, error } =
    useQuery<GetClassRoomsWhereTeacherWasCandidateQueryResult>(
      GetClassRoomsWhereTeacherWasCandidateQuery,
      {
        fetchPolicy: "cache-and-network",
        variables: { teacherId, classRoomIds: competingClassRoomIds },
        skip: competingClassRoomIds.length === 0,
      },
    );

  const classRoomIdsLostByTeacher = useMemo(
    () => new Set(data?.getClassRoomsWhereTeacherWasCandidate ?? []),
    [data],
  );

  return { classRoomIdsLostByTeacher, loading: loading && !data, error };
}
